import { ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

// A search text kept in the URL's `?q=` (replaced, so it makes no history entries; other query keys stay).
export function useSearchQuery() {
  const route = useRoute()
  const router = useRouter()
  const query = ref(typeof route.query.q === 'string' ? route.query.q : '')
  watch(query, (q) => {
    const rest = { ...route.query }
    delete rest.q
    void router.replace({ query: q ? { ...rest, q } : rest })
  })
  return query
}
